import { registerComponent, triggerEvent } from "helpers";
import { WYATTDialog } from "wyatt";

registerComponent(
  "wyatt-modal",
  class WyattModal extends WYATTDialog {
    open() {
      super.open();

      triggerEvent(this.dialog, "modalOpen");
    }

    close() {
      super.close();

      triggerEvent(this.dialog, "modalClose");
    }
  },
);
